import { render, staticRenderFns } from "./AddComplementaryExam.vue?vue&type=template&id=011031b4&scoped=true"
import script from "./AddComplementaryExam.vue?vue&type=script&lang=js"
export * from "./AddComplementaryExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011031b4",
  null
  
)

export default component.exports